import React,{ Fragment } from 'react';
import PlainBanner from '../../components/common/PlainBanner';
import Section from '../../components/common/Section';
import styles from '../../styles/pages/selfserve.module.scss';
import router, { withRouter, NextRouter } from 'next/router';
import ProgressStep from '../../components/selfserve/ProgressStep';
import Config from '../../config';
import Head from 'next/head';
import {getParamsObjectFromString, getStaticPath} from '../../utils';
import NoPlanFound1 from '../../components/selfserve/NoPlanFound1';
import PlanPage from '../../components/selfserve/PlanPage';
import SelectService from '../../components/selfserve/SelectService';
import SelectIssue from '../../components/selfserve/SelectIssue';
import EnterAddress from '../../components/selfserve/EnterAddress';
import ConfirmSrDetails from '../../components/selfserve/ConfirmSrDetails';
import CopaySummary from '../../components/selfserve/CopaySummary';
import ServiceRequestSuccess from '../../components/selfserve/ServiceRequestSuccess';
import ServiceRequestFailure from '../../components/selfserve/ServiceRequestFailure';
import LockDown from '../../components/selfserve/LockDown';
import ChildPlanPage from '../../components/selfserve/ChildPlanPage';
import DeviceInformation from '../../components/selfserve/DeviceInformation';
import MultiServiceRequestStatus from '../../components/selfserve/MultiServiceRequestStatus';
import { HOMECARE_PLANS, HOMECARE_PREMIUM_PRODUCTS } from '../../constants/index';
// Main component ends
import {
            updateSelectedPlan, planCoversFetched,updateSrReopenReason,
            updateSelectedCover,updateSelectedProblems, changeProgress,
            updateSrCreationSource,changeLandedOnPage,updateUrlLanded,
            updateAddressDetails,
            updateUserPlans, updateMobileNumber,updateParentDeviceDetails, canUploadDocuments,
            updateIsServicePgChargesApplicable
        } from '../../redux/actions/selfserveActions';
import { connect } from 'react-redux';
import {GetPlans, GetPlanCovers, GetPlanDetails, GetIsRestricted} from '../../api/selfserve';
import { GetSubIssues } from '../../api/contact-us/index';
import  ReopenRequestAlert  from '../../components/selfserve/ReopenRequestModal';
import { OpenRequestAlert } from '../../components/selfserve/OpenRequestModal';
import ActivationAlert from '../../components/selfserve/ActivationRequiredModal';
import { planNotFoundPage } from '../../tracking/selfserveTracking';
import { SetCSRFToken, URLS, getCustomerCookie,getIsAuthenticateCookie } from "../../api/cookies";
import Cookies from 'js-cookie';
import { addAppRenderParams, getActiveIds } from '../../utils/selfserve';
import { raiseSrPageViewed } from '../../tracking/segment/loginPage';
import { BLOCKED_CHANNELS, isBrandBlocked } from '../../utils/selfserve';
import { trackPage } from '../../tracking';
import { getPageViewData, pushToSegmentIdentify } from '../../utils/tracking';
import AddAddress from '../../components/selfserve/AddAddress';
import { WebsiteSchema } from '@/constants/schema';
import SchemaLoader from '@/components/hoc/SchemaLoader';
import UploadDocuments from '../../components/selfserve/uploadDocuments';
import page_data from '../../data/page_data';



export async function getServerSideProps()
{
    const res:any = await GetSubIssues();
    return {
      props:
      {
        subissues:res? res.data : {},
        meta_tag_data: page_data["selfserve"].meta_tag ? page_data["selfserve"].meta_tag : [],
        pageName: 'selfserve'
      }
    }
}


interface SelfServeProps {

    selfserveReducer: any,
    customerReducer: any,
    updateSelectedPlan: (data:any) => void,
    planCoversFetched: (data:any) => void,
    updateSelectedCover: (data:any) => void,
    updateSelectedProblems: (data:any) => void,
    changeProgress:(data:any) => void,
    updateSrReopenReason: (data:any) => void,
    updateSrCreationSource: (data:any) => void,
    changeLandedOnPage: (data:any) => void,
    updateUrlLanded: (data:any) => void,
    updateAddressDetails: (data:any) => void,
    updateUserPlans: (data:any) => void,
    router: NextRouter,
    subissues: any,
    meta_tag_data:any,
    updateMobileNumber : (data:any) => void
    updateParentDeviceDetails: (data:any) => void
    updateIsServicePgChargesApplicable: (data:any) => void
}
interface SelfServeSelectionStep {
    current_step: number,
    tracker_step: number,
    covers: number,
    page_loading: boolean,
    BASE_URL: string,
    OG_IMAGE: string,
    reopenEligibleSR: boolean,
    isActiveSR: boolean,
    activeSRRefNo: string,
    isCopayPlan: boolean,
    planName: string,
    copayAmount: string,
    activePlan: boolean,
    is_authenticate: boolean,
    api_calling:boolean,
    customer_exists: boolean,
    osid:string,
    appRender: boolean,
    counter:number

}
class SelfServe extends React.Component<SelfServeProps, SelfServeSelectionStep>  {

    state:SelfServeSelectionStep = {
        current_step: this.props.selfserveReducer.current_step,
        is_authenticate: this.props.customerReducer.is_authenticate,
        tracker_step: 1,
        covers: 0,
        page_loading: false,
        BASE_URL : Config.BASE_URL,
        OG_IMAGE: getStaticPath(""),
        reopenEligibleSR: false,
        isActiveSR:false,
        activeSRRefNo: '',
        isCopayPlan:false,
        planName: '',
        copayAmount:'',
        activePlan:false,
        api_calling:false,
        customer_exists:false,
        osid:'',
        appRender: false,
        counter:20
    }

    handleLeavePage =(event) =>{
        const e = event || window.event;
        e.preventDefault();
        if(this.props.selfserveReducer.current_step == 10){

            return false

        } else {

            if (e) {
                e.returnValue = ''; // Legacy method for cross browser support
            }
            return '';

        }

    }

    setCustomerExists = (value) => {
        this.setState({customer_exists:value})
    }

    isPlanActive = (item) => {
        if (!item.plan_validity.is_valid) {

            // if (item.reopen_eligible || item.active_sr_exists || item.plan_status == 'Activation Pending') {
            if (item.reopen_eligible || item.active_sr_exists ||  ['Activation Pending', 'Unknown'].includes(item.plan_status)) {
                return false
            } else {
                return true
            }

        } else {
            return false
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleLeavePage);
    }

    autoLogin=(osid,data,coverName,queryParams,countDownTimer)=>{
        const router = this.props.router;
        let is_authenticate = getIsAuthenticateCookie();
        this.setState({counter:this.state.counter-1})
        if (!(this.state.counter > 0)|| is_authenticate) {
            if(!is_authenticate){
                router.push(`/login/?next=/selfserve/?osid=${osid}`)
            }else{
            // When Only OSID is present in URL
            // queryParams = osid=2145789324

            // data['osid'] = osid;

            // Initiating Page Loader
            
            GetPlanDetails(osid, {

                "application": "website",
                "data": JSON.stringify(data)

            }).then((res: any) => {
                Cookies.set('is_authenticate', true)
                if(res && res.data){
                    if(BLOCKED_CHANNELS.includes(res.data.channel) || (isBrandBlocked(res.data))){
                        // blocking the flow for Blocked Channels by replacing the URL and loading the Page to prevent
                        // direct Landing scenario
                        window.location.href = window.location.pathname

                    }
                    else{

                        // Redux Store Updation for PlanDetails
                        const plan = res.data;
                        const oldData = plan.old_data;

                        this.props.updateSelectedPlan(plan);

                        // Updating SR no
                        this.setState({
                            activeSRRefNo: plan.sr_id
                        });

                        // Updating Planname
                        this.setState({
                            planName: plan.plan_title
                        });

                        // Setting Copay Amount
                        this.setState({
                            copayAmount: plan.copay_amount
                        });


                        // Device Id Extracting from PlanDetails
                        const coversData = {
                            "token_id": this.props.selfserveReducer.token_id,
                            "osid": osid?.split(":")[0]
                        }
                        coversData['cover_name'] = coverName;
                        // Updating address with oldData values if exist
                        if(oldData.hasOwnProperty('old_order')){
                            if(oldData.old_order.address.pincode){
                                const addressData = {
                                    address: { address: oldData.old_order.address.address, address2: oldData.old_order.address.address_line2, pincode: oldData.old_order.address.pincode, city: oldData.old_order.address.city, state: oldData.old_order.address.state }
                                }
                                this.props.updateAddressDetails(addressData)
                            }
                        }else {
                            const temp_address = plan?.order?.address ? plan?.order?.address : {}
                            const addressData = {
                                address: { 
                                    address : temp_address?.address,
                                    address2 : temp_address?.address2,
                                    pincode : temp_address?.pincode,
                                    city : temp_address?.city,
                                    state : temp_address?.state,
        
                                }
                            }
                            this.props.updateAddressDetails(addressData);
                        }

                        // This if condition is to handle plan status
                        // if the plan is already exhausted
                        if(!this.isPlanActive(plan)){
                            if (HOMECARE_PREMIUM_PRODUCTS.includes(plan.plan_name)) {
                                this.getOrderItemsDetails(queryParams)
                            }else{
                                //test code
                                let deviceId;
                                if (HOMECARE_PLANS.includes(plan.plan_name)) {
                                    deviceId = plan.device_detail?.device_id ? plan.device_detail.device_id : null;
                                }else{
                                    deviceId = plan.device_detail.device_id
                                }
                                //test code

                                GetPlanCovers({
                                    "application": "website",
                                    "data": JSON.stringify(coversData)

                                }).then((covers: any) => {
                                    this.props.updateIsServicePgChargesApplicable(covers?.data?.is_service_pg_charges_applicable || false)
                                    if (HOMECARE_PLANS.includes(plan.plan_name)) {
                                        this.props.planCoversFetched(covers.data.device);
                                        this.getOrderItemsDetails(queryParams)
                                    }
                                    else {

                                        this.props.planCoversFetched(covers.data[deviceId]);
                                        // REopen Case handle
                                        if(covers.data[deviceId].length === 1 && covers.data[deviceId][0]['sr_id'] !== '' && covers.data[deviceId][0]['reopen']) {

                                            this.props.updateSelectedCover({index: 0, selectedCover: covers.data[deviceId]});
                                            // setting ulr landed to true
                                            this.props.updateUrlLanded(true);
                                            this.changeReopenEligibleSR(true);
                                            this.setState({'osid':plan.osid})
                                            this.setPageLoading(false);

                                        } else if (plan.active_sr_exists) {
                                            // SR Exist Case
                                            this.changeIsActiveSR(true);
                                            this.setState({ 'osid':plan.osid})
                                            this.setPageLoading(false);

                                        }
                                        else if(plan.is_copay) {
                                                this.props.changeLandedOnPage('covers');
                                                this.props.changeProgress(4);
                                                if(this.props.selfserveReducer.planCovers.length == 1){
                                                    this.props.updateSelectedCover({index: 0, selectedCover: covers.data[deviceId]});
                                                }
                                            this.setPageLoading(false);
                                        }
                                        else {

                                            if (covers.data && covers.data.hasOwnProperty(deviceId)) {

                                                // this.setState({covers: covers.data[deviceId].length})
                                                // this.props.planCoversFetched(covers.data[deviceId]);

                                                if (covers.data[deviceId].length === 1 && covers.data[deviceId][0].type != "service") {

                                                    this.props.updateSelectedCover({ index: 0, selectedCover: covers.data[deviceId] });

                                                    this.props.updateSelectedCover({ index: 0, selectedCover: covers.data[deviceId] });

                                                    this.props.changeLandedOnPage('issues');
                                                    this.props.changeProgress(5);
                                                    // Stopping the Loader
                                                    this.setPageLoading(false);

                                                }
                                                else if (coverName) {
                                                    let selectedCover = covers.data[deviceId].filter(cover => cover.is_selected === true);
                                                    if (selectedCover.length > 0 && (selectedCover[0].reopen || selectedCover[0].is_valid)) {
                                                        this.props.updateSelectedCover({ index: 0, selectedCover: selectedCover });
                                                    }
                                                    this.props.changeLandedOnPage('covers');
                                                    this.props.changeProgress(4);
                                                    this.setPageLoading(false);
                                                } else {

                                                    this.props.changeLandedOnPage('covers');
                                                    this.props.changeProgress(4);
                                                    // Stopping the Loader
                                                    this.setPageLoading(false);

                                                }
                                            }
                                        }

                                    }

                                }).catch((err:any)=>{
                                    addAppRenderParams(router)
                                    console.log("error =>",err)
                                    router.push('/')
                                })
                            }


                        } else {
                            // perform some action here
                            // need to stop page loading
                            this.setPageLoading(false);
                            this.props.changeProgress(12);
                        }
                    }

                } else {

                    // Stopping the Loader & taking to self-serve home
                    // if GetPlanDetail Api Fails
                    this.setPageLoading(false);
                    // router.replace("", undefined, { shallow: true });
                    router.push('/')
                    addAppRenderParams(router)
                }
            }).catch((err:any)=>{
                console.log("error",err)
                router.push('/')
            })
            }  
          clearInterval(countDownTimer) 
        }}


    componentDidMount = () => {
        SetCSRFToken(URLS.SET_CSRF).then(()=>{
            pushToSegmentIdentify({id: this.props.customerReducer.id, phone:this.props.customerReducer.phone, email: this.props.customerReducer.email, name: this.props.customerReducer.name})
        })
        if(["/selfserve","/selfserve?next=/selfserve"].includes(router.asPath)  || router.asPath.includes("nav=")){
            router.push("/account/plans")
        }
        window.addEventListener('beforeunload', this.handleLeavePage);
        this.setPageLoading(true);
        trackPage('Selfserve', {...getPageViewData()})
        if(getParamsObjectFromString(window.location.href)['urlParams']['app_render'] === "true"){
            this.setState({appRender: true})
        }
        GetIsRestricted().then((res:any) => {
            if(res?.data.is_restricted){

                this.props.changeProgress(0);
                this.setPageLoading(false);

            }
            else {
                const router = this.props.router;
                let params = getParamsObjectFromString(router.asPath)
                const selfserveLocalStorage = JSON.parse(localStorage.getItem('selfserve_data') || '{}');

                // Taking QueryParams from Router for Direct URL Landing Scenerio
                let queryParams:any = params.urlParams
                let osid:any = queryParams.osid
                let coverName = queryParams.cover_name
                let srCreatedSource = selfserveLocalStorage.sr_created_source || (queryParams.sr_source ? 'selfserve ' + String(queryParams.sr_source) : '');
                if(srCreatedSource) {
                    this.props.updateSrCreationSource(srCreatedSource);
                }
                // Partial Payload for API Calls
                const data = {

                    "token_id": this.props.selfserveReducer.token_id,
                }
                if (osid) {
                    if(queryParams.source){
                        this.setState({counter:0})
                    }     
                    let countDownTimer = setInterval( ()=> {
                        this.autoLogin(osid,data,coverName,queryParams,countDownTimer)
                      }, 1000)  
                }
                else{
                    const customerCookie = getCustomerCookie()
                    const tokenId = queryParams.token_id
                    const phone = queryParams.phone
                    if(customerCookie || (tokenId && phone)){
                        let get_plans_data = {}
                        if(customerCookie){
                            get_plans_data = {
                                "token_id": customerCookie.token_id,
                                "phone": customerCookie.phone
                            }
                            this.props.updateMobileNumber(customerCookie.phone)
                        }
                        else{
                                get_plans_data = {
                                    "token_id": tokenId,
                                    "phone": phone
                                }
                                this.props.updateMobileNumber(phone)
                        }
                    }
                    else{
                        router.push('/login/?next=/selfserve')
                    }
                }
            }
        })

    }

    componentDidUpdate = () => {
        // if(!this.props.router.query.osid && !this.props.selfserveReducer.userPlans && this.props.customerReducer.isAuthenticated){
        //     if(this.props.selfserveReducer.token_id && this.props.selfserveReducer.mobileNumber && !this.state.api_calling){
        //         const data = {
        //         "token_id": this.props.selfserveReducer.token_id,
        //         "phone": this.props.selfserveReducer.mobileNumber
        //     }
        //         this.setPageLoading(true);
        //         this.setState({api_calling:true})
        //         GetPlans(
        //             {
        //                 "application": "website",
        //                 "data": JSON.stringify(data)
        //             }
        //         ).then((res:any) => {
        //             if (res?.data.plans && res?.data.plans.length > 0) {
        //                 this.props.updateUserPlans(res.data.plans);
        //                 this.props.changeProgress(3);
        //                 this.setPageLoading(false);

        //             } else {
        //                 planNotFoundPage(); //gtm tracking event
        //                 this.props.changeProgress(6);
        //                 this.setPageLoading(false);
        //             }
        //         })
        //     }
        // }

    }

    getOrderItemsDetails = (queryParams)=>{

             const customerCookie = getCustomerCookie()
             const tokenId = queryParams.token_id
             const phone = queryParams.phone
             let osid:any = queryParams.osid
             if(customerCookie || (tokenId && phone)){
                 let get_plans_data = {}
                 if(customerCookie){
                     get_plans_data = {
                         "token_id": customerCookie.token_id,
                         "phone": customerCookie.phone
                     }
                     this.props.updateMobileNumber(customerCookie.phone)
                 }
                 else{
                         get_plans_data = {
                             "token_id": tokenId,
                             "phone": phone
                         }
                         this.props.updateMobileNumber(phone)
                 }
                 GetPlans(
                     {
                         "application": "website",
                         "data": JSON.stringify(get_plans_data)
                     }
                 ).then((res:any) => {
                     if (res?.data.plans && res?.data.plans.length > 0) {
                         this.props.updateUserPlans(res.data.plans);
                         res.data.plans.forEach(element => {
                             if (element.osid == osid?.split(":")[0]) {
                                 //update current plan details
                                 const parentPlanDetails = element
                                 parentPlanDetails["button_disabled"] = true
                                 this.props.updateParentDeviceDetails(parentPlanDetails);
                                 this.props.changeProgress(14);
                             }
                         });

                         this.setPageLoading(false);

                     } else {
                        addAppRenderParams(router)
                        planNotFoundPage(); //gtm tracking event
                        this.props.changeProgress(6);
                        this.setPageLoading(false);
                     }
                 }).catch(() => {
                    addAppRenderParams(router)
                })
             }
    }

    getActiveComponent = (step) => {
        let all_labels = this.props.customerReducer?.address?.map((item) => { return item.label; })
        // Returns valid component based on current_step
        switch (step) {

            case 0:
                return <LockDown subIssues={this.props.subissues}/>
                break;
            case 3:
                return <PlanPage subIssues={this.props.subissues} setPageLoading={this.setPageLoading} customerExists={this.state.customer_exists} />
                break;

            case 4:
                return <SelectService setPageLoading={this.setPageLoading}/>
                break;

            case 5:
                return <SelectIssue setPageLoading={this.setPageLoading}/>
                break;

            case 6:
                return <NoPlanFound1 subIssues={this.props.subissues} header='Oops!' subTextOne="Unable to find the Plan with the provided Mobile Number" buttonOneText="I will try with different Mobile Number" urlDestination="" selfserveReducer={this.props.selfserveReducer}/>
                break;

            case 7:
                return <EnterAddress setPageLoading={this.setPageLoading}/>
                break;

            case 8:
                return <ConfirmSrDetails setPageLoading={this.setPageLoading}/>
                break;

            case 9:
                return <CopaySummary setPageLoading={this.setPageLoading}/>
                break;

            case 10:
                return <ServiceRequestSuccess />
                break;

            case 11:
                return <ServiceRequestFailure subIssues={this.props.subissues}/>
                break;

            case 12:
                // Plan is expired for url landing scenarios
                return <NoPlanFound1 subIssues={this.props.subissues} header='This link is no longer active!' subTextOne="To view the details of your plan, click 'My Account' button below" buttonOneText="My Account" urlDestination="/request-a-service/login" selfserveReducer={this.props.selfserveReducer}/>
                break;

            case 13:
                return null
                break;

            case 14:
                return <ChildPlanPage subIssues={this.props.subissues} setPageLoading={this.setPageLoading} customerExists={this.state.customer_exists} />
                break;

            case 15:
                return <DeviceInformation setPageLoading={this.setPageLoading}/>
                break;

            case 17:
                return <MultiServiceRequestStatus subIssues={this.props.subissues}/>
                break;
            case 18:
                return <AddAddress existing_label={all_labels} isSelfserve={true}/>
                break;
            case 19:
                return <UploadDocuments setPageLoading={this.setPageLoading} />
                break;
            default:
                return <PlanPage subIssues={this.props.subissues} setPageLoading={this.setPageLoading} customerExists={this.state.customer_exists} />
                break;
        }
    }

    setPageLoading = (pageLoader) => {
        this.setState({
          page_loading:pageLoader
        });
    }

    changeReopenEligibleSR = (para:boolean) =>{
        this.setState({
            reopenEligibleSR: para
        });
    }

    changeIsActiveSR = (para:boolean) =>{
        this.setState({
            isActiveSR: para
        });
    }

    setIsCopayPlan = (para:boolean) =>{
        this.setState({
            isCopayPlan: para
        });
    }

    setActivePlan = (para:boolean) =>{
        this.setState({
            activePlan: para
        });
    }

    render() {
        return (
                <Fragment>
                    <Head>
                        <title>{this.props.meta_tag_data.tag_title}</title>
                        <link rel="icon" href="/favicon.ico" />
                        <meta name="description" content={this.props.meta_tag_data.tag_description}></meta>
                        <meta property="og:title" content={this.props.meta_tag_data.tag_title}/>
                        <meta property="og:description" content={this.props.meta_tag_data.tag_description}/>
                        <meta property="og:url" content={`${this.state.BASE_URL}${this.props.router.asPath}`}/>
                        <meta property="og:image" content={this.state.OG_IMAGE}/>
                        <link rel="canonical" href={`${this.state.BASE_URL}${this.props.router.asPath}`}></link>
                        <SchemaLoader schema={WebsiteSchema} />
                    </Head>
                    {/* Loader */}
                    <div className={`${this.state.appRender ? styles.app_render : ''}`}>
                        <div data-loading={this.state.page_loading} data-fullpage={this.state.page_loading}></div>
                        <PlainBanner  title="" subtitle="">
                            {[0,6,10,11,12].includes(this.props.selfserveReducer.current_step) ? null : <ProgressStep step_number={this.props.selfserveReducer.tracker_step} landed_on_page={this.props.selfserveReducer.landed_on_page} upload_document={this.props.selfserveReducer.canUploadDocuments}/> }
                        </PlainBanner>
                        <Section dataBg="shade-2" style={{paddingTop:'1px',paddingBottom:this.state.appRender ? '200px':'100px',position:'relative'}}>

                            <div className="container" id={[1,2,3,4,5,7,8].includes(this.props.selfserveReducer.current_step) ? "selfserve-bottom-sticky" : 'temp'}>
                            {/* <div className="container" id="selfserve-bottom-sticky"> */}

                                <div className={`${this.props.selfserveReducer.current_step===7 ? "no_styling" : styles.self_serve_parent}`} id={'selfserve_container'} data-varient={[0,6,10,11,12].includes(this.props.selfserveReducer.current_step) ? 'move-top': null}>

                                    {this.getActiveComponent(this.props.selfserveReducer.current_step)}

                                </div>
                            </div>

                        </Section>
                        <ReopenRequestAlert is_open={this.state.reopenEligibleSR} closeModal={this.changeReopenEligibleSR}  planDetail={this.props.selfserveReducer.planDetails} osid={this.state.osid}/>
                        <OpenRequestAlert is_open={this.state.isActiveSR} closeModal={this.changeIsActiveSR} refNo={this.state.activeSRRefNo} planDetail={this.props.selfserveReducer.planDetails} osid={this.state.osid} setPageLoading={this.setPageLoading} category={this.props.selfserveReducer.deviceDetails?.category}/>
                        <ActivationAlert is_open={this.state.activePlan} closeModal={this.setActivePlan} activation_link={this.props.selfserveReducer.planDetails.activation_link} osid={this.state.osid}/>
                    </div>
                </Fragment>
        )
    }
}

const mapStateToProps = (state:any) => {
    return {
        selfserveReducer:state.selfserveReducer,
        customerReducer:state.customerReducer
    }
}

const mapDispatchToProps = (dispatch:any) => {

    return {
      updateSelectedPlan: (data:any) => dispatch(updateSelectedPlan(data)),
      planCoversFetched: (data:any) => dispatch(planCoversFetched(data)),
      updateSelectedCover: (data:any) => dispatch(updateSelectedCover(data)),
      changeProgress: (data:any) => dispatch(changeProgress(data)),
      updateSelectedProblems: (data:any) => dispatch(updateSelectedProblems(data)),
      updateSrReopenReason: (data:any) => dispatch(updateSrReopenReason(data)),
      updateSrCreationSource: (data:any) => dispatch(updateSrCreationSource(data)),
      changeLandedOnPage: (data:any) => dispatch(changeLandedOnPage(data)),
      updateUrlLanded: (data:any) => dispatch(updateUrlLanded(data)),
      updateAddressDetails: (data:any) => dispatch(updateAddressDetails(data)),
      updateUserPlans: (data:any) => dispatch(updateUserPlans(data)),
      updateMobileNumber: (data:any) => dispatch(updateMobileNumber(data)),
      updateParentDeviceDetails: (data:any) => dispatch(updateParentDeviceDetails(data)),
      updateIsServicePgChargesApplicable: (data:boolean) => dispatch(updateIsServicePgChargesApplicable(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (withRouter(SelfServe));
